import projectConfig from '../../../modules/project/config'
import ProjectListColumnModel from '../../../modules/project/components/list/models/project-list-column-model'
import { sanitizeListColumns } from '../../util/sanitizeListColumns'
import request from '@/modules/base/util/request'

// actions
const FINSIHED_FETCHING_PROJECT_LIST_SETTING = 'FINSIHED_FETCHING_PROJECT_LIST_SETTING'
const ERROR_FETCHING_PROJECT_LIST_SETTING = 'ERROR_FETCHING_PROJECT_LIST_SETTING'
const SHOW_PROJECTS_LOADER = 'SHOW_PROJECTS_LOADER'
const HIDE_PROJECTS_LOADER = 'HIDE_PROJECTS_LOADER'
const SET_PROJECT_LIST_ITEMS = 'SET_PROJECT_LIST_ITEMS'
const SET_PROJECTS_PAGINATION = 'SET_PROJECTS_PAGINATION'
const SET_PROJECTS_FILTER = 'SET_PROJECTS_FILTER'
const REFRESH_PROJECTS = 'REFRESH_PROJECTS'
const STOP_REFRESHING_PROJECTS = 'STOP_REFRESHING_PROJECTS'

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    autoSizeColumns: true,
    columns: [],
  },
  filter: 'all',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered projects
    totalCount: 0, // count of all projects
    limit: 20, // max projects on page
  },
  shouldRefresh: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_PROJECT_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_PROJECTS_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_PROJECTS_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_PROJECT_LIST_ITEMS:
      const { projects } = action
      return Object.assign({}, state, {
        items: projects,
      })

    case SET_PROJECTS_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_PROJECTS_FILTER:
      const { filter } = action
      return Object.assign({}, state, {
        filter,
        pagination: initialState.pagination,
      })

    case REFRESH_PROJECTS:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING_PROJECTS:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_PROJECT_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_PROJECTS_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_PROJECTS_LOADER,
  }
}

export const setProjectListItems = (projects) => {
  return {
    type: SET_PROJECT_LIST_ITEMS,
    projects,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH_PROJECTS,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING_PROJECTS,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_PROJECTS_PAGINATION,
    pagination,
  }
}

export const setActiveFilter = (filter) => {
  return {
    type: SET_PROJECTS_FILTER,
    filter,
  }
}

const finishedFetchingProjectListSetting = (setting) => {
  return {
    type: FINSIHED_FETCHING_PROJECT_LIST_SETTING,
    setting,
  }
}

const errorFetchingProjectListSetting = (error) => {
  return {
    type: ERROR_FETCHING_PROJECT_LIST_SETTING,
    error,
  }
}

export const fetchProjectListSetting = () => {
  return (dispatch) => {
    request(projectConfig.projectListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { autoSizeColumns, columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const projectColumns = sanitizedColumns.map((column) => {
          column.displayed = true
          return new ProjectListColumnModel(column)
        })

        dispatch(finishedFetchingProjectListSetting({ autoSizeColumns, columns: projectColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingProjectListSetting(error))
      })
  }
}
